import { https } from "../http";
import store from "../store";
import swal from "sweetalert";

import {
  setLoading,
  setLoadingSaveProfile,
  setProfile,
} from "../store/reducers/profile";
import { clearSession, getCookie, showError } from "../utils/index";
import { hasDesignEntitlement } from "../utils/entitlements";

// Cache the org's sign-in branding so the pre-auth AuthPage (which has no user
// context yet) can render it for returning users on this device. Cleared on
// logout / failed auth.
export const LOGIN_BRAND_KEY = "loginBrand";
const cacheLoginBrand = (profileLike) => {
  try {
    const wl = profileLike?.business?.whiteLabel;
    if (wl?.enabled && hasDesignEntitlement(profileLike)) {
      // NOTE: sign-in background/tagline are an Advanced feature that is not
      // live yet, so they are intentionally NOT cached or applied. Only the
      // brand logo/name (Brand identity) are used on the sign-in page.
      localStorage.setItem(
        LOGIN_BRAND_KEY,
        JSON.stringify({
          brandName: wl.brandName || profileLike?.business?.companyName || "",
          logo: profileLike?.business?.logo || wl.logo || "",
          logoDark: wl.logoDark || "",
          primaryColor: wl.primaryColor || "",
        })
      );
    } else {
      localStorage.removeItem(LOGIN_BRAND_KEY);
    }
  } catch {
    /* ignore */
  }
};

// GET
const getProfile = async (showLoading = true, token, currentTimezone) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https(token).get("/me", {
      params: {
        timeZone: currentTimezone,
      },
    });

    if (response?.status === 200) {
      let temp = response?.data?.user;
      if (temp?.user?.active === false) {
        clearSession();
        showError("Your session has expired");
        window.location.href = "/login";
      }
      store.dispatch(
        setProfile({
          ...temp,
          currentDate: response.data?.currentDate,
          subscriptionExpired: response.data?.subscriptionExpired,
          admin: response.data?.isAdmin,
          isFreeAccount: response.data?.isFreeAccount,
        }),
      );
      cacheLoginBrand(temp);
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    if (getCookie("token")) showError("Your session has expired");
    clearSession();
    // window.location.href = "/";
    return false;
  }
};

// PUT
const updateProfile = async (data, navigate) => {
  try {
    store.dispatch(setLoadingSaveProfile(true));
    let response = await https().put("/me", data);
    if (response?.status === 200) {
      // if (response?.data?.isNewEmail) {
      //   removeCookie("token");
      //   navigate("/");
      // } else {
      //   getProfile();
      //   }
      getProfile();
      return response?.data;
    }
  } catch (error) {
    let _error = error?.response?.data?.message;
    if (_error?.includes("duplicate") && _error?.includes("name"))
      showError("This name is already taken");
    else showError(_error, error?.response?.status);
    store.dispatch(setLoadingSaveProfile(false));
    return false;
  }
};

const verifyPasswordAndUpdateEmail = async (payload, navigate) => {
  try {
    let response = await https().post("/auth/verify-password", payload);
    if (response?.status === 200) {
       await updateProfile({
        name: payload?.name,
        npi: payload?.npi,
        email: payload?.newEmail,
        oldEmail: payload?.email,
        emailUpdated: payload?.email === payload?.newEmail ? false : true,
      });
      // const res = await updateProfile({
      //   name: payload?.name,
      //   email: payload?.newEmail,
      // });
      // if (res) {
      //   removeCookie("token");
      //   navigate("/");
      // }
    }

    return true;
  } catch (error) {
    let _error = error?.response?.data?.message;
    swal(_error || "", "", "error");
    // showError(_error, error?.response?.status);
    return false;
  }
};

export const getPresignedUploadUrl = async (path) => {
  try {
    const response = await https().get("/me/generate-presigned-url", {
      params: { path },
    });

    return response?.data?.uploadURL;
  } catch (error) {
    console.error("Error fetching pre-signed URL", error);
    throw error;
  }
};

const updateProfilePhoto = async (data) => {
  try {
    store.dispatch(setLoadingSaveProfile(true));
    let response = await https().post("/me/updateProfile", data);
    if (response?.status === 200) {
      getProfile();
      return response?.data;
    }
  } catch (error) {
    let _error = error?.response?.data?.message;
    showError(_error, error?.response?.status);
    store.dispatch(setLoadingSaveProfile(false));
    return false;
  }
};

// PUT
const updateBusinessProfile = async (data) => {
  try {
    store.dispatch(setLoadingSaveProfile(true));
    let response = await https().put("/me/business", data);
    if (response?.status === 200) {
      getProfile();
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setLoadingSaveProfile(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

export {
  getProfile,
  updateBusinessProfile,
  updateProfile,
  updateProfilePhoto,
  verifyPasswordAndUpdateEmail,
};
